import { useState } from "react";
import { AnalyzeStep } from "@/components/workspace/AnalyzeStep";
import { Globe } from "lucide-react";
import { cn } from "@/lib/utils";

const AnalyzePage = () => {
  const [isAnalyzing, setIsAnalyzing] = useState(false);

  const handleAnalysisComplete = (results: any) => {
    console.log("Analysis complete:", results);
    setIsAnalyzing(false);
    // Handle the analysis results
  };

  const handleAnalysisStart = () => {
    setIsAnalyzing(true);
  };

  return (
    <div className="container py-6 max-w-7xl mx-auto">
      <div className="text-center mb-8 space-y-4">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gradient-to-r from-blue-500/10 to-blue-500/10 mb-4 shadow-lg">
          <Globe className="h-8 w-8 text-blue-600 dark:text-blue-400" />
        </div>
        <h1 className={cn(
          "text-3xl font-bold bg-gradient-to-r from-blue-600 to-sky-500",
          "bg-clip-text text-transparent"
        )}>
          Website Analysis
        </h1>
        <p className="text-muted-foreground max-w-md mx-auto">
          Enter your SaaS website URL below to analyze your product, audience, and content strategy.
        </p>
      </div>
      
      <div className="max-w-3xl mx-auto">
        <div className={cn(
          "bg-gradient-to-r from-blue-600/10 to-blue-600/10 rounded-xl shadow-lg overflow-hidden",
          "transition-all duration-300",
          isAnalyzing ? "p-8" : "p-6"
        )}>
          <AnalyzeStep 
            onAnalysisComplete={handleAnalysisComplete} 
            onAnalysisStart={handleAnalysisStart}
          />
        </div>
      </div>
    </div>
  );
};

export default AnalyzePage;
